const v14018 = require("./120.js").getSymbolSize;
exports.getRowColCoords = function (p18220) {
  if (p18220 === 1) {
    return [];
  }
  const v14019 = Math.floor(p18220 / 7) + 2;
  const vV14018 = v14018(p18220);
  const v14020 = vV14018 === 145 ? 26 : Math.ceil((vV14018 - 13) / (v14019 * 2 - 2)) * 2;
  const vA787 = [vV14018 - 7];
  for (let vLN1173 = 1; vLN1173 < v14019 - 1; vLN1173++) {
    vA787[vLN1173] = vA787[vLN1173 - 1] - v14020;
  }
  vA787.push(6);
  return vA787.reverse();
};
exports.getPositions = function (p18221) {
  const vA788 = [];
  const v14021 = exports.getRowColCoords(p18221);
  const v14022 = v14021.length;
  for (let vLN02564 = 0; vLN02564 < v14022; vLN02564++) {
    for (let vLN02565 = 0; vLN02565 < v14022; vLN02565++) {
      if ((vLN02564 !== 0 || vLN02565 !== 0) && (vLN02564 !== 0 || vLN02565 !== v14022 - 1) && (vLN02564 !== v14022 - 1 || vLN02565 !== 0)) {
        vA788.push([v14021[vLN02564], v14021[vLN02565]]);
      }
    }
  }
  return vA788;
};